<template>
  <v-toolbar
    v-if="routeName === 'WebCall' && screenWidth >= 600 ? false : true"
    data-action="get-height"
    class="toolbar--white get-height"
    flat
    app
  >
    <v-spacer />

    <DropdownLanguage v-if="false" />

    <v-toolbar-items class="corp-header__items">
      <DropdownCompany />
      <DropdownUser />
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex'
import DropdownLanguage from 'components/corpHeader/DropdownLanguage'
import DropdownCompany from 'components/corpHeader/DropdownCompany'
import DropdownUser from 'components/corpHeader/DropdownUser'

export default {
  name: 'Header',
  props: {
    screenWidth: {
      type: Number
    }
  },
  components: {
    DropdownLanguage,
    DropdownCompany,
    DropdownUser
  },
  computed: {
    ...mapState({
      claims: ({ userClaims }) => userClaims.claims,
      name: ({ session }) => {
        const { business } = session.user
        return business.name || business.email
      }
    }),

    routeName () {
      return this.$route.name
    }
  },
  methods: {
    resetPassword () {
      this.$emit('resetPassword')
    },

    logoutSession () {
      this.$emit('logoutSession')
    }
  }
}
</script>

<style lang="scss">
.v-toolbar__content {
  padding-left: 0;
  padding-right: 0;
}

.corp-header__items {
  display: none;

  @media (min-width: 768px) {
    display: block;
  }
}

.reset-company {
  border-top: 1px solid $gray-4;
  cursor: pointer;
  overflow: hidden;

  .v-list__tile__content {
    height: 52px;
  }

  .v-list__tile__title {
    font-size: 14px;
    height: 52px;
    line-height: 1.8;
    padding: 15px 16px;

    &:hover {
      background: rgba(0,0,0,0.04);
    }
  }
}
</style>
